export function isEmbeddedWindow(): boolean {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}
